import React from 'react';
import { JuniorLayout } from '../../components/layout/JuniorLayout';
import { ActivityShell } from '../../components/activity/ActivityShell';
import { RequireJuniorSession } from '../../components/auth/RequireJuniorSession';
import { BoomJuniorShell } from '../../components/boom/BoomJuniorShell';
import { DiscoverRhythmApp } from '../../boom/apps/DiscoverRhythmApp';
import { useJuniorAliveNav } from '../../contexts/JuniorAliveNavContext';

function BoomDescubreRitmoPageInner() {
  const { navigateAlive } = useJuniorAliveNav();

  return (
    <JuniorLayout immersive>
      <ActivityShell
        title="Descubre el ritmo"
        subtitle="Escucha y adivina las figuras"
        backTo="/ritmo"
        backLabel="Ritmo"
        immersive
        lockViewport
        fullBleed
      >
        <BoomJuniorShell>
          <DiscoverRhythmApp onBack={() => navigateAlive('/ritmo')} />
        </BoomJuniorShell>
      </ActivityShell>
    </JuniorLayout>
  );
}

export default function BoomDescubreRitmoPage() {
  return (
    <RequireJuniorSession>
      <BoomDescubreRitmoPageInner />
    </RequireJuniorSession>
  );
}
